import { render, staticRenderFns } from "./ReceiveTask.vue?vue&type=template&id=2a72bad5&"
import script from "./ReceiveTask.vue?vue&type=script&lang=js&"
export * from "./ReceiveTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a72bad5')) {
      api.createRecord('2a72bad5', component.options)
    } else {
      api.reload('2a72bad5', component.options)
    }
    module.hot.accept("./ReceiveTask.vue?vue&type=template&id=2a72bad5&", function () {
      api.rerender('2a72bad5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bpmnProcessDesigner/package/penal/task/task-components/ReceiveTask.vue"
export default component.exports